import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getAuditsByReferenceIdAndType = api(
    function getAuditsByReferenceIdAndType(referenceId, type, filter, skip, take) {
        return query(
            gql`
                query GetAuditsByReferenceIdAndType(
                    $referenceId: String
                    $type: String
                    $filter: JSONObject
                    $skip: Int
                    $take: Int
                ) {
                    getAuditsByReferenceIdAndType(
                        referenceId: $referenceId
                        type: $type
                        filter: $filter
                        skip: $skip
                        take: $take
                    ) {
                        id
                        shortDescription
                        longDescription
                        referenceId
                        type
                        date
                        userId
                        userName
                        payload
                    }
                }
            `,
            { referenceId, type, filter, skip, take },
            { returns: "getAuditsByReferenceIdAndType" }
        )
    }
)

export const getAuditPayload = api(function getAudit(id) {
    return query(
        gql`
            query GetAudit($id: String!) {
                getAudit(id: $id) {
                    payload
                }
            }
        `,
        { id },
        { returns: "getAudit.payload" }
    )
})
